<template>
  <div class="instruccion">
    <p class="intro">Sigue estos pasos para cambiar la contraseña de tu <strong>WiFi Starlink</strong> desde la app.</p>

    <div class="pasos">

      <div class="paso">
        <div class="instruccion-paso">
          <div class="paso-numero">1</div>
          <p>Antes de <strong>empezar</strong>, asegúrate de tener acceso a la app de <strong>Starlink</strong> en tu teléfono y de estar <strong>conectado al WiFi</strong>.</p>
        </div>
      </div>

      <div class="paso">
        <div class="instruccion-paso">
          <div class="paso-numero">2</div>
          <p><strong>Entra a la app de Starlink</strong> en tu teléfono y pulsa el botón <strong>Configuración</strong> (icono de engranaje).</p>
        </div>
        <div class="captura">
            <img src="/img/instrucciones/cambiowifistarlink/1.jpeg" alt="Acceso a Starlink - app o web" />
          </div>
      </div>

      <div class="paso">
        <div class="instruccion-paso">
          <div class="paso-numero">3</div>
          <p>Pulsa <strong>Router</strong> y, a continuación, <strong>STARLINK</strong> en la sección de redes, tal como se muestra en la captura.</p>
        </div>
        <div class="captura">
          <img src="/img/instrucciones/cambiowifistarlink/2.jpeg" alt="Menú Configuración o Cuenta" />
        </div>
      </div>

      <div class="paso">
        <div class="instruccion-paso">
          <div class="paso-numero">4</div>
          <p>Podrás ver el <strong>Nombre de red</strong> y la <strong>Contraseña</strong>. Escribe el nombre y la contraseña que quieras y pulsa el botón <strong>Guardar</strong> para aplicar los cambios.</p>
        </div>
        <div class="captura">
          <img src="/img/instrucciones/cambiowifistarlink/3.jpeg" alt="Formulario para cambiar contraseña WiFi" />
        </div>
      </div>

      <div class="paso">
        <div class="instruccion-paso">
          <div class="paso-numero">5</div>
          <p><strong>Importante:</strong> esto desconectará a todos los dispositivos de la red Starlink, incluido tu teléfono. Tendrás que <strong>volver a conectarte al WiFi</strong> con la nueva contraseña que estableciste.</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
/* Estilos en @/styles/instrucciones.css (compartidos por todos los componentes de instrucciones) */
</style>
